class GroupProductCarousel extends HTMLElement {
  #index = 0;
  #timer;
  #hovered = false;
  #focused = false;
  #reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  connectedCallback() {
    this.viewport = this.querySelector('[data-carousel-viewport]');
    this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
    this.dots = [...this.querySelectorAll('[data-carousel-dot]')];
    if (!this.viewport || this.slides.length < 2) return;

    this.querySelector('[data-carousel-previous]')?.addEventListener('click', () => this.#goTo(this.#index - 1));
    this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.#goTo(this.#index + 1));
    this.dots.forEach((dot) => dot.addEventListener('click', () => this.#goTo(Number(dot.dataset.index))));
    this.viewport.addEventListener('scroll', this.#handleScroll, { passive: true });
    this.viewport.addEventListener('keydown', this.#handleKeydown);
    this.addEventListener('mouseenter', () => { this.#hovered = true; });
    this.addEventListener('mouseleave', () => { this.#hovered = false; });
    this.addEventListener('focusin', () => { this.#focused = true; });
    this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.#focused = false; });
    this.#startAutoplay();
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #goTo(index) {
    const nextIndex = (index + this.slides.length) % this.slides.length;
    this.viewport.scrollTo({ left: nextIndex * this.viewport.clientWidth, behavior: this.#reducedMotion.matches ? 'auto' : 'smooth' });
    this.#setActive(nextIndex);
  }

  #setActive(index) {
    this.#index = index;
    this.dots.forEach((dot, dotIndex) => dot.toggleAttribute('aria-current', dotIndex === index));
  }

  #handleScroll = () => {
    window.requestAnimationFrame(() => this.#setActive(Math.round(this.viewport.scrollLeft / this.viewport.clientWidth)));
  };

  #handleKeydown = (event) => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); this.#goTo(this.#index - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); this.#goTo(this.#index + 1); }
  };

  #startAutoplay() {
    if (this.dataset.autoplay !== 'true' || this.#reducedMotion.matches) return;
    const interval = Number(this.dataset.interval) || 6000;
    this.#timer = window.setInterval(() => { if (!this.#hovered && !this.#focused && !document.hidden) this.#goTo(this.#index + 1); }, interval);
  }
}

if (!customElements.get('group-product-carousel')) customElements.define('group-product-carousel', GroupProductCarousel);
